import { GlDisclosureDropdown, GlTooltipDirective } from '@gitlab/ui';
import { __ } from '~/locale';
export const i18n = {
    artifacts: __('Artifacts'),
    artifactSectionHeader: __('Download artifacts')
};
export default {
    name: 'PipelinesArtifacts',
    i18n,
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        GlDisclosureDropdown
    },
    props: {
        artifacts: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    computed: {
        items () {
            return [
                {
                    name: this.$options.i18n.artifactSectionHeader,
                    items: this.artifacts.map(({ name, path })=>({
                            text: name,
                            href: path,
                            extraAttrs: {
                                download: '',
                                rel: 'nofollow'
                            }
                        }))
                }
            ];
        },
        shouldShowDropdown () {
            return this.artifacts?.length;
        }
    }
};
